import { Button, Group, Pane, SearchInput } from 'evergreen-ui';
import React, { FC } from 'react';

import { Action } from '../controllers/app.controller';
import { SearchGroup } from '../models';

export interface EmployeeListActionsComponentProps {
  dispatch: React.Dispatch<Action>;
  searchGroup: SearchGroup;
  children?: never;
}

export const EmployeeListActionsComponent: FC<EmployeeListActionsComponentProps> = ({ dispatch, searchGroup }) => (
  <Pane display="flex" flexDirection="row" gap={8} alignItems="flex-end">
    <SearchInput
      placeholder="Search by member name"
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch({ type: 'memberSearch', searchKey: e.target.value });
      }}
    />
    <Group>
      {Object.values(SearchGroup).map(value => (
        <Button
          key={value}
          color={searchGroup === value ? '#00BD9D' : undefined}
          backgroundColor={searchGroup === value ? '#E7FAF6' : '#FFFFFF'}
          onClick={() => dispatch({ type: 'memberSearchGroupUpdate', searchGroup: value })}
        >
          {value}
        </Button>
      ))}
    </Group>
    <Button appearance="primary" intent="success" onClick={() => dispatch({ type: 'memberSearchSubmit' })}>
      Search
    </Button>
    <Button marginLeft="auto" onClick={() => dispatch({ type: 'addMemberGroup' })}>
      Add New Employee
    </Button>
  </Pane>
);
